import React, { Component } from "react";

class FormTitle extends Component {
    render() {
        return <h3 style={{ display: this.props.display }}>{this.props.title}</h3>;
    }
}

export default FormTitle;
